import React from "react";
import styled from "styled-components";
import { theme } from "../../styles/theme";
import { graphql, useStaticQuery } from "gatsby";
import Container from "../../styles/Container";

const PricingSection = styled.section``;
const VehicleGrid = styled.div`
  /* margin: -10rem 0 0 0; */
  padding: 4rem;
  margin-top: 3rem;
  background: var(--lightgrey);
  border-radius: 0.7rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  @media ${theme.devices.md} {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 2rem;
  }
  @media ${theme.devices.lg} {
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
  }
`;
const Vehicle = styled.article`
  /* border: 1px solid blue; */
  border-radius: 0.7rem;
  padding: 1rem;

  background: rgba(255, 255, 255, 0.13);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
`;
const VehicleTitle = styled.h1`
  color: var(--lightblue);
  margin-bottom: 2rem;

  transform: skewY(-2deg);
  font-size: clamp(2em, 7vw, 2.3em);
`;

const Service = styled.div`
  font-family: Roboto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
`;
const ServiceTitle = styled.p`
  margin: 0;
`;
const ServicePrice = styled.p`
  font-weight: 800;
  margin: 0;
`;

export default function Prices({ vehicles }) {
  // const { vehicles } = useStaticQuery(graphql`
  //   {
  //     vehicles: allSanityVehicle {
  //       edges {
  //         node {
  //           id
  //           name
  //           services {
  //             _key
  //             title
  //             price
  //           }
  //         }
  //       }
  //     }
  //   }
  // `);

  return (
    <PricingSection>
      <Container>
        <VehicleGrid>
          {vehicles.edges.map((v) => {
            const {
              node: { name, services },
            } = v;
            return (
              <Vehicle>
                <VehicleTitle>{name}</VehicleTitle>
                {services.map((service) => (
                  <Service>
                    <ServiceTitle>{service.title}</ServiceTitle>
                    <ServicePrice>{service.price}</ServicePrice>
                  </Service>
                ))}
              </Vehicle>
            );
          })}
        </VehicleGrid>
      </Container>
    </PricingSection>
  );
}
